<template>
<div class="drawer-nav-item" @click="selectContent(item)">
  <div class="item-icon">
    <img :src="svgIconPath" />
  </div>
  <div class="item-title">
    {{ item.langTitle }}
  </div>
</div>
</template>

<script>
export default {
  components: {},
  props: {
    item: {
      type: Object,
      required: true,
    },
    isEmbed: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    svgIconPath() {
      return require(`@assets/images/${this.item.icon}.svg`);
    },
  },
  mounted() {},
  methods: {
    selectContent(item) {
      this.$emit('select-content', item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.drawer-nav-item {
  align-items: center;
  background-color: $color-kitchen-drawer-nav-item-bg;
  border: 1px solid $color-kitchen-drawer-nav-item-border;
  border-radius: $base-border-radius;
  display: flex;
  flex-basis: 49.1%;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 0.5rem;
  padding: 1.5rem 1rem;

  &:nth-child(odd) {
    margin-right: 0.5rem;
  }

  &:hover {
    box-shadow: $color-grocery-list-item-shadow;
    cursor: pointer;
  }

  &:active {
    box-shadow: none;
    cursor: pointer;
  }

  .item-icon {
    flex: 1;
    margin-right: 0.5rem;

    img {
      width: 75%;
    }
  }

  .item-title {
    @extend %typography-medium;

    color: $color-grocery-list-item-text;
    flex: 3;
    font-weight: 600;
  }
}
</style>
